import React, { useEffect, useRef } from 'react';

// Zoho Forms embed (replaces Web3Forms). Entries land in Zoho Forms; Zoho Flow pushes them to CRM.
// Mirrors Zoho's JavaScript embed snippet: the form posts "perma|height" to resize the iframe,
// and "perma|height|x" after submit to also scroll the thank-you message into view.
const ZohoFormEmbed = ({ form, perma, height, title }) => {
  const iframeRef = useRef(null);
  const src = `https://forms.zohopublic.com/nursetechmedical1/form/${form}/formperma/${perma}`
    + `?zf_rszfm=1&referrername=${encodeURIComponent(window.location.href)}`;

  useEffect(() => {
    const onMessage = (event) => {
      const iframe = iframeRef.current;
      if (!iframe || event.source !== iframe.contentWindow || typeof event.data !== 'string') return;
      const parts = event.data.split('|');
      if ((parts.length !== 2 && parts.length !== 3) || !parts[0] || !src.includes(parts[0])) return;
      const newHeight = `${parseInt(parts[1], 10) + 15}px`;
      if (parts.length === 3) {
        iframe.scrollIntoView();
        setTimeout(() => { iframe.style.height = newHeight; }, 500);
      } else {
        iframe.style.height = newHeight;
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [src]);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      title={title}
      aria-label={title}
      // scrollMarginTop keeps the post-submit scroll clear of the fixed header
      style={{ border: 'none', width: '100%', height, transition: 'all 0.5s ease', scrollMarginTop: '96px' }}
    />
  );
};

export default ZohoFormEmbed;
